import { createAsyncThunk } from "@reduxjs/toolkit";
import { normalize } from "normalizr";

import magnifiAPI from "../../services/api/magnifi";
import { tournament } from "../schemas";
import { populateTournamentDetails } from "./slice";

export const getTournaments = createAsyncThunk("tournament/getTournaments", async (payload) => {
  try {
    const response = await magnifiAPI.getTournaments(payload);

    return {
      ...response.data,
      ...(response.data.success ? normalize(response.data.tournaments, [tournament]) : {}),
    };
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getTournamentsList = createAsyncThunk("tournament/getTournamentsList", async (payload) => {
  try {
    const response = await magnifiAPI.getTournamentsList(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const createNewTournament = createAsyncThunk("tournament/createNewTournament", async (payload) => {
  try {
    const response = await magnifiAPI.createNewTournament(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const deleteTournament = createAsyncThunk("tournament/deleteTournament", async (payload) => {
  try {
    const response = await magnifiAPI.deleteTournament(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const updateTournament = createAsyncThunk("tournament/UpdateTournament", async (payload) => {
  try {
    const response = await magnifiAPI.updateTournament(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getAllTournaments = createAsyncThunk("tournament/getAllTournaments", async (payload) => {
  try {
    const response = await magnifiAPI.getAllTournaments(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const validateAddTournamentThroughCsv = createAsyncThunk(
  "tournament/validateAddTournamentThroughCsv",
  async (payload) => {
    try {
      const response = await magnifiAPI.validateAddTournamentThroughCsv(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const createBulkTournaments = createAsyncThunk("tournament/createBulkTournaments", async (payload) => {
  try {
    const response = await magnifiAPI.createBulkTournaments(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getTournamentById = createAsyncThunk("tournament/getTournamentById", async (payload) => {
  try {
    const response = await magnifiAPI.getTournamentById(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const populateTournamentDetailsAsync = createAsyncThunk(
  "tournament/populateDetailsAsync",
  async (data, { dispatch, getState }) => {
    dispatch(populateTournamentDetails(data));

    return getState().tournament.tournamentDetails;
  },
);

export const getTournamentDataById = createAsyncThunk("tournament/getTournamentDataById", async (payload) => {
  try {
    const response = await magnifiAPI.getTournamentDataById(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const updateTournamentScoreboard = createAsyncThunk("tournament/updateTournamentScoreboard", async (payload) => {
  try {
    const response = await magnifiAPI.updateTournamentScoreboard(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
